import { useCallback, useState } from 'react';

import { currentMonth, isValidMonth } from './month';

const STORAGE_KEY = 'cs.finance.month';

/**
 * Shared month lens for the Finance operational tabs. Persisted to localStorage
 * so switching tabs (which remounts the screen) keeps the selected month.
 */
export function useFinanceMonth(): [string, (month: string) => void] {
  const [month, setMonth] = useState<string>(() => {
    if (typeof window !== 'undefined') {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored && isValidMonth(stored)) {
        return stored;
      }
    }
    return currentMonth();
  });

  const update = useCallback((next: string) => {
    setMonth(next);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, next);
    }
  }, []);

  return [month, update];
}
